import React, { Fragment, useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

//Components
import Landing from './components/Landing';
import AboutUs from './components/AboutUs';
import ContactInfo from './components/ContactInfo';

import DirectDB from './components/admin/DirectDB';
import WorkerList from './components/admin/WorkerList';
import ShiftListAll from './components/admin/ShiftListAll';
import ClientList from './components/admin/ClientList';
import ExpenseList from './components/admin/ExpenseList';
import ServerLog from './components/admin/ServerLog';
import DatabaseReset from './components/admin/DatabaseReset';

import InputShift from './components/InputShift';
import ListShifts from './components/ListShifts';
import SignIn from './components/SIgnIn';
import Navbar from './components/Navbar';
import MyBMenu from './components/MyBMenu';

function App() {

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(0);

  const setAuth = (boolean) => {
    setIsAuthenticated(boolean);
  }
  const setAdm = (three_val) => {
    setIsAdmin(three_val);
  }

  async function isAuth() {
    try {
      const response = await fetch("https://www.beyondcommunityaccess.com/auth/is-verify", {
        method: "GET",
        headers: { token: localStorage.token }
      })

      const parseRes = await response.json();
      if (parseRes.valid === true) {
        setIsAuthenticated(true);
        if (parseRes.admin === 1) {
          setIsAdmin(1);
        } else if (parseRes.admin === 2) {
          setIsAdmin(2);
        }

      } else {
        setIsAuthenticated(false);
        setIsAdmin(0);

      }

    } catch (err) {
      console.error("Cannot check if authenticated")
      console.error(err.message);
    }
  }

  useEffect(() => {
    isAuth();
  }, [])
  return (
    // <Fragment>
    //   <div className="container">
    //     <InputShift />
    //     <ListShifts />
    //   </div>
    // </Fragment>
    <Fragment>
      <Router>
        {/* <Navbar signedIn={signedIn} setSignedIn={setSignedIn} /> */}
        <MyBMenu setAuth={setAuth} setAmd={setAdm} authenticationStatus={isAuthenticated} adminStatus={isAdmin} />
        <Navbar setAuth={setAuth} setAmd={setAdm} authenticationStatus={isAuthenticated} adminStatus={isAdmin}></Navbar>
        <Routes>
          <Route exact path='/' element={<Landing />} />
          <Route exact path='/AboutUs' element={<AboutUs />} />
          <Route exact path='/ContactInfo' element={<ContactInfo />} />
          <Route exact path='/InputShift' element={isAuthenticated && isAdmin === 0 ? <InputShift /> : isAuthenticated && isAdmin !== 0 ? <Navigate to="/" /> : <Navigate to="/SignIn" />} />
          <Route exact path='/ListShifts' element={isAuthenticated && isAdmin === 0 ? <ListShifts /> : isAuthenticated && isAdmin !== 0 ? <Navigate to="/" /> : <Navigate to="/SignIn" />} />

          <Route exact path='/DirectDB' element={isAuthenticated && isAdmin >= 1 ? <DirectDB is_admin={isAdmin} /> : <Navigate to="/SignIn" />} />
          <Route exact path='/WorkerList' element={isAuthenticated && isAdmin >= 1 ? <WorkerList is_admin={isAdmin} /> : <Navigate to="/SignIn" />} />
          <Route exact path='/ShiftListAll' element={isAuthenticated && isAdmin >= 1 ? <ShiftListAll is_admin={isAdmin} /> : <Navigate to="/SignIn" />} />
          <Route exact path='/ClientList' element={isAuthenticated && isAdmin >= 1 ? <ClientList is_admin={isAdmin} /> : <Navigate to="/SignIn" />} />
          <Route exact path='/ExpenseList' element={isAuthenticated && isAdmin >= 1 ? <ExpenseList is_admin={isAdmin} /> : <Navigate to="/SignIn" />} />


          <Route exact path='/DatabaseReset' element={isAuthenticated && isAdmin === 2 ? <DatabaseReset is_admin={isAdmin} /> : <Navigate to="/SignIn" />} />
          <Route exact path='/ServerLog/:date' element={isAuthenticated && isAdmin === 2 ? <ServerLog /> : <Navigate to="/SignIn" />} />


          {/* <Route exact path='/SignIn' render={props => !isAuthenticated ? <SignIn {...props} /> : <Navigate to="/" />} /> */}
          <Route exact path='/SignIn' element={!isAuthenticated ? <SignIn setAuth={setAuth} setAdm={setAdm} /> : <Navigate to="/ListShifts" />} />
        </Routes>
      </Router>
    </Fragment>
  );
}

export default App;
